<template>
	<div class="login-page">
		<!-- Navbar -->
		<nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
			<div class="container">
				<div class="navbar-wrapper w-100">
					<a class="navbar-brand w-100" href="https://www.bigscoots.com/" target="_blank">
						<img src="../assets/img/bigscoots-logo/logo_light.svg" alt="Bigscoots" width="70%" class="center login-bs-logo">
					</a>
				</div>
			</div>
		</nav>
		<!-- End Navbar -->
		<div class="wrapper wrapper-full-page ">
			<div class="full-page section-image">
				<div class="content">
					<div class="container">
						<div class="col-lg-4 col-md-6 ml-auto mr-auto">
							<div class="card card-login" v-if="!asyncDone">
								<div class="card-body">
									<!-- Show the loader when async operation is going on -->
									<div class="loader"></div>
								</div>
							</div>
							<form class="form" @submit.prevent="resetPass" v-else>
								<div class="card card-login">
									<div class="card-header ">
										<div class="card-header ">
											<h3 class="header text-center">Reset Password</h3>
										</div>
									</div>
									<div class="card-body ">
										<div class="form-group input-group mb-2">
											<div class="input-group-prepend">
						<span class="input-group-text">
							<i class="nc-icon nc-email-85"></i>
						</span>
											</div>
											<input type="email" required class="form-control" placeholder="Registered Email" v-model.trim="email">
										</div>
										<p class="text-danger text-center mb-0" v-if="feedback !== ''"><strong>{{feedback }}</strong></p>
									</div>
									<div class="card-footer pt-0">
										<button type="submit" class="btn btn-warning btn-round btn-block mb-3" :disabled="email === ''">Reset Password
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
				<footer class="footer footer-black  footer-white ">
					<div class="container-fluid">
						<div class="row">
							<nav class="footer-nav">
								<ul>
									<li>
										<a href="https://www.bigscoots.com/" target="_blank">Bigscoots</a>
									</li>
									<li>
										<a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">WordPress Hosting</a>
									</li>
									<li>
										<a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">Privacy Policy</a>
									</li>
									<li>
										<a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">SLA</a>
									</li>
								</ul>
							</nav>
							<div class="credits ml-auto">
				<span class="copyright">
					©{{ currentYear }}, made with
					<i class="fa fa-heart heart"></i> by <a href="https://acnam.com" class="text-light" target="_blank">Acnam</a>
				</span>
							</div>
						</div>
					</div>
				</footer>
				<div class="full-page-background"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import {auth} from '@/firebase/init'
	import swal from 'sweetalert2'

	export default {
		name: "login",
		data() {
			return {
				email: '',
				feedback: ''
			}
		},
		computed: {
			currentYear() {
				return new Date().getFullYear()
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			}
		},
		methods: {
			resetPass() {
				if (this.email !== '') {
					// Check if the provided email id is actually an email or not
					const emailCheckRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (emailCheckRegex.test(this.email)) {
						// Start async operation
						this.$store.dispatch("async/stateUpdate", {state: false})

						// Send the password reset mail to the address given
						auth.sendPasswordResetEmail(this.email)
							.then(() => {
								this.$store.dispatch("async/stateUpdate", {state: true})

								swal({
									title: "Password Reset Email Sent",
									text:
										"A password reset email has been sent to your registered email. Please check your email inbox or spam folder and click on the reset link provided to generate a new password for your BigScoots WPO Portal.",
									type: "success",
									confirmButtonText: "Okay",
									confirmButtonColor: "#6ACF98"
								})
									.then(result => {
										if (result.value) {
											this.email = ''
											this.feedback = ''

											this.$router.push({name: 'login'})
										}
									})
							})
							.catch(err => {
								this.$store.dispatch("async/stateUpdate", {state: true})

								this.feedback = err.message
								this.addLog({
									name: "Error reset password: " + this.email,
									message: err.message,
									level: "danger"
								})
							})
					} else {
						swal({
							title: "Not a Valid Email!",
							text:
								"Please make sure you have entered your registered email address correctly.",
							type: "error",
							confirmButtonText: "Try Again",
							confirmButtonColor: "#EE8057"
						})
					}
				} else {
					swal({
						title: "Not a Valid Email!",
						text:
							"Please make sure that you have entered your registered email address correctly and hasn't made any mistakes as it seems not to be a valid email.",
						type: "error",
						confirmButtonText: "Try Again",
						confirmButtonColor: "#EE8057"
					})
				}
			}
		},
		mounted() {
			document.body.classList.add('login-page')
			$('.form-control').on("focus", function () {
				$(this).parent('.input-group').addClass("input-group-focus");
			}).on("blur", function () {
				$(this).parent(".input-group").removeClass("input-group-focus");
			});
		},
		beforeDestroy() {
			document.body.classList.remove('login-page')
		}
	};
</script>


<style lang="scss">
	.login-page {
		.full-page-background {
			background-image: url('../assets/img/bg/fabio-mangione.jpg');
		}
		.section-image {
			&:after {
				background-color: rgba(90, 124, 253, 0.94)
			}
		}
		.login-bs-logo {
			max-height: 60px;
		}
	}
</style>
